import { render, staticRenderFns } from "./GenderPieChart.vue?vue&type=template&id=56df9c0b&scoped=true"
import script from "./GenderPieChart.vue?vue&type=script&lang=js"
export * from "./GenderPieChart.vue?vue&type=script&lang=js"
import style0 from "./GenderPieChart.vue?vue&type=style&index=0&id=56df9c0b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56df9c0b",
  null
  
)

export default component.exports